/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Provisioning Devices module.
────────────────────────────────────────────────────────────────*/

import { api as apiClient } from '../../../lib/api';

export interface Device {
    id: number;
    uuid?: string;
    macAddress: string;
    description?: string;
    vendorId: number;
    modelId: number;
    templateId: number;
    accounts?: unknown[];
    keys?: unknown[];
    expansionModules?: unknown[];
    phonebook?: unknown[];
    ipAddress?: string;
    lastProvisioned?: string;
    vendor?: { id: number; name: string; uuid?: string };
    model?: { id: number; model: string; vendorId: number; isSystem?: boolean; imageFile?: string };
    template?: { id: number; name: string; modelId: number; vendorId: number; serverSettingsId: number };
    createdAt: string;
    updatedAt: string;
}

export const getDevices = (domainId?: number) => {
    const params = domainId !== undefined ? `?domainId=${domainId}` : '';
    return apiClient.get<Device[]>(`/api/apps/provisioning/devices${params}`).then(res => res.data);
};
export const getDevice = (id: number | string) => apiClient.get<Device>(`/api/apps/provisioning/devices/${id}`).then(res => res.data);
export const createDevice = (data: Record<string, unknown>) => apiClient.post<Device>('/api/apps/provisioning/devices', data).then(res => res.data);
export const updateDevice = (id: number | string, data: Record<string, unknown>) => apiClient.put<Device>(`/api/apps/provisioning/devices/${id}`, data).then(res => res.data);
export const deleteDevice = (id: number | string) => apiClient.delete(`/api/apps/provisioning/devices/${id}`);
export const scanNetwork = (cidr: string) => apiClient.post<{ ip: string, mac: string, vendor?: string }[]>('/api/apps/provisioning/devices/scan', { cidr }, { timeout: 60000 }).then(res => res.data);
export const getLocalNetworkCidr = () => apiClient.get<{ cidr: string }>('/api/apps/provisioning/devices/local-network').then(res => res.data);
export const importDevices = (csvContent: string) => apiClient.post<{ success: boolean; count: number; errors: string[] }>('/api/apps/provisioning/devices/import', { csvContent }).then(res => res.data);
export const previewConfig = (data: Record<string, unknown>) => apiClient.post<{ config: string }>('/api/apps/provisioning/devices/preview', data).then(res => res.data);
